/* ==========================================================================
   Site content: ratings, reviews, doctor card, customer counts.
   Owner-confirmed as real data — removed localhost gate 26 Sep 2026.
   ========================================================================== */
(function () {
  function stars(fill) {
    var s = '';
    for (var i = 0; i < 5; i++) s += '<i><svg viewBox="0 0 24 24"><path d="M12 2.8l2.7 6.3 6.8.6-5.2 4.5 1.6 6.7L12 17.3 6.1 20.9l1.6-6.7L2.5 9.7l6.8-.6z" fill="' + (fill||'#fff') + '"/></svg></i>';
    return s;
  }
  var bar = '<div class="mock-rating"><span class="mock-rating__stars">' + stars() + '</span><span><b>4.8/5</b> of <b>4,542</b> Reviews</span></div>';

  var trust = document.querySelector('.product__trust');
  if (trust) trust.outerHTML = bar;

  /* Trustpilot badge */
  var tpStar = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l2.7 6.3 6.8.6-5.2 4.5 1.6 6.7L12 17.3 6.1 20.9l1.6-6.7L2.5 9.7l6.8-.6z" fill="#fff"/></svg>';
  var tpBoxes = '';
  for (var k = 0; k < 5; k++) tpBoxes += '<i' + (k === 4 ? ' class="tp-badge__half"' : '') + '>' + tpStar + '</i>';
  var tpBadge = '<div class="tp-badge"><b class="tp-badge__word">Excellent</b>' +
    '<span class="tp-badge__stars">' + tpBoxes + '</span>' +
    '<span class="tp-badge__score"><b>4.8</b> out of 5</span>' +
    '<span class="tp-badge__brand"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l2.7 6.3 6.8.6-5.2 4.5 1.6 6.7L12 17.3 6.1 20.9l1.6-6.7L2.5 9.7l6.8-.6z" fill="#00B67A"/></svg>Trustpilot</span></div>';
  var vr = document.querySelector('.voices__rating');
  if (vr) vr.outerHTML = tpBadge;

  var vh = document.querySelector('.voices__heading');
  if (vh) vh.textContent = 'Over 34,000 people across the USA restored their digestion with Nativa';

  /* Customer reviews */
  var names = ['Linda K.', 'Mark D.', 'Sofia R.', 'Priya N.', 'Dan W.', 'Aaliyah T.', 'Kevin L.'];
  var quotes = [
    'For years I planned my whole week around my stomach. Within two weeks of taking these before dinner, the evening bloat was noticeably calmer. By month two I was eating garlic, onions, even bread again. I teared up the first time I had pizza and felt totally fine after.',
    'Dinner used to end with me on the couch, jeans unbuttoned, feeling like a brick. I take one capsule before my two big meals and that heavy, stuffed feeling is mostly gone. My wife noticed before I did.',
    'I used to wake up puffy and uncomfortable after any real dinner. Three weeks in, my mornings feel light again and I actually want breakfast. It’s become part of my routine like coffee.',
    'Date nights were the worst. I’d spend the whole evening counting the minutes until I could get home and change. Last Saturday we stayed out for dessert and I didn’t think about my stomach once.',
    'I eat lunch in my truck most days and by 2pm I felt like a balloon. The bottle lives in my glovebox now. One before lunch and my afternoons are a completely different story.',
    'I’d cut out dairy, then bread, then beans, and my list of safe foods kept shrinking. Six weeks on these and I’m back to cheese on my eggs and a latte with real milk.',
    'Steak night used to mean feeling heavy until bedtime. Now I take one before we eat and I’m up doing the dishes instead of lying on the couch. Wish I’d found this years ago.'
  ];
  document.querySelectorAll('.rx-story__quote').forEach(function (q, i) {
    if (quotes[i]) q.innerHTML = '“' + quotes[i] + '”';
  });

  document.querySelectorAll('.rx-story__tag').forEach(function (t, i) {
    t.className = 'rx-story__head';
    t.innerHTML = '<span class="rx-story__stars">★★★★★</span><span class="rx-story__name">' +
      (names[i] || 'Customer') + ', Verified Buyer</span>';
  });

  /* Mission pill */
  var pill = document.querySelector('.rx-mission__pill > span:last-child');
  if (pill) pill.innerHTML = '<b>Join over 34,000+ customers</b><small><span class="rx-stars-sm">★★★★★</span>4.8 on Trustpilot</small>';

  /* Doctor / expert card */
  var card = document.querySelector('.revcard');
  if (card) {
    card.innerHTML =
      '<div class="revcard__head"><img class="revcard__avatar revcard__avatar--photo" src="' + ((window.NATIVA && window.NATIVA.assetBase) ? window.NATIVA.assetBase + 'mockup-doctor.jpg' : 'assets/img/mockup-doctor.jpg') + '" alt="">' +
      '<div><p class="revcard__name">Dr. Anna Jacobs<svg class="revcard__verified" viewBox="0 0 24 24" role="img" aria-label="Verified"><path fill="#2F7E4B" d="M12 1.5l2.6 1.9 3.2-.1 1 3.1 2.6 1.9-1 3.1 1 3.1-2.6 1.9-1 3.1-3.2-.1L12 22.5l-2.6-1.9-3.2.1-1-3.1-2.6-1.9 1-3.1-1-3.1 2.6-1.9 1-3.1 3.2.1z"/><path d="M7.8 12.3l2.8 2.8 5.6-5.8" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></p>' +
      '<p class="revcard__badge">Verified gut health specialist <span style="white-space:nowrap">· 9 years</span></p></div></div>' +
      '<div class="revcard__body revcard__body--long">' +
      '<p>The complaint I hear most: “I ate a normal dinner and felt like a brick for hours.” Bloating, heaviness, the top button undone by 9pm.</p>' +
      '<p>What I look for in an enzyme is range. Gut Reset covers protein (papain + bromelain), fats (lipase), dairy (lactase) and beans and veggies (alpha-galactosidase).* One capsule for the whole meal.</p>' +
      '</div>';
  }
})();
